// API URLs
const BASE_URL = "https://oncoevidaapi.catalink.eu";

// Request configuration
export const CONFIG = {
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
};

// Function to set the Authorization header dynamically
export const setAuthToken = (token) => {
  if (token) {
    CONFIG.headers["Authorization"] = `Bearer ${token}`;
  } else {
    delete CONFIG.headers["Authorization"];
  }
};

// Authentication endpoints
export const LOGIN = `${BASE_URL}/api/auth/signin`;
export const LOGOUT = `${BASE_URL}/api/auth/signout`;
export const REGISTER = `${BASE_URL}/api/auth/signup`;
export const STATUS = `${BASE_URL}/api/auth/status`;
export const VERIFY = `${BASE_URL}/api/auth/verify`;
export const UPDATEPASSWORD = `${BASE_URL}/api/auth/updatepassword`;
// for forget password
export const RESETPASS = `${BASE_URL}/api/auth/resetpassword`;
export const CHANGEPASS = `${BASE_URL}/api/auth/changepassword`;

// Datasets endpoints
export const ALL_DATASETS = `${BASE_URL}/api/datasets`;
export const DATASET = `${BASE_URL}/api/datasets`;

// Table endpoints
export const TABLE = `${BASE_URL}/api/tables`;

// Pivot table endpoints
export const PIVOT = `${BASE_URL}/api/pivots`;

// Chart endpoint
export const CHART = `${BASE_URL}/api/charts`;

// Dashboard endpoint
export const DASHBOARD = `${BASE_URL}/api/dashboards`;

//cookies
export const COOKIE = `${BASE_URL}/api/cookies`;

// User endpoints
export const USER = `${BASE_URL}/api/users`;

// Setting endpoints
export const SETTING = `${BASE_URL}/api/settings`;

// Report bug endpoint
export const reportBug = `${BASE_URL}/api/report-bug`;

// Recommendations endpoint
export const RECOMMENDATIONS = `${BASE_URL}/api/forecast`;

// Correlation endpoint
export const CORRELATION = `${BASE_URL}/api/correlation`;

// NUTS inventory endpoint
export const NUTS_INVENTORY = `${BASE_URL}/api/nuts-inventory`;
